import {Component, DestroyRef, inject, OnInit, output} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent} from "@ng-select/ng-select";
import {PendingUsersService} from "../../../../services/pending-users.service";
import {JobsService} from "../../../../services/jobs.service";

@Component({
  selector: 'pending-user-approve-modal',
  imports: [
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    ReactiveFormsModule
  ],
  templateUrl: './pending-user-approve-modal.html',
})
export class PendingUserApproveModal implements OnInit {
  approve = output<{ roleId: string, locationIds: string[] }>();
  close = output();

  locations: any[] = [];
  roles: any[] = [];
  userForm!: FormGroup;

  private readonly pendingUserService = inject(PendingUsersService);
  private readonly jobService = inject(JobsService);
  private readonly fb = inject(FormBuilder);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.initForm();
    this.getLocations();
    this.getRoles();
  }

  initForm() {
    this.userForm = this.fb.group({
      roleId: [null],
      selectAllLocations: [false],
      locationIds: [[]]
    });

    this.userForm.get('selectAllLocations')!.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
      const locationIdsControl = this.userForm.get('locationIds')!;
      if (value) {
        locationIdsControl.setValue(this.locations.map(loc => loc.location_id));
        locationIdsControl.disable();
      } else {
        locationIdsControl.enable();
      }
    });
  }

  getLocations() {
    this.jobService.getLocations().then((data: any) => {
      this.locations = data;
    });
  }

  getRoles() {
    this.pendingUserService.getRoles().then((data: any) => {
      this.roles = data.Data;
    });
  }

  clearRole() {
    this.userForm.get('roleId')!.setValue("1");
  }

  approveUser() {
    const formValues = this.userForm.getRawValue();
    this.approve.emit({roleId: formValues.roleId, locationIds: formValues.locationIds});
  }

  closeModal() {
    this.close.emit();
  }
}
